import React from "react";

interface TimeSlot {
  start: string;
  end: string;
}

interface BusinessHours {
  sunday: TimeSlot[];
  monday: TimeSlot[];
  tuesday: TimeSlot[];
  wednesday: TimeSlot[];
  thursday: TimeSlot[];
  friday: TimeSlot[];
  saturday: TimeSlot[];
}

interface OperatingHoursProps {
  daysOfWeek: string[];
  businessHours: BusinessHours;
  timezone: any;
  isBusinessHourAvailable: boolean;
}

export const OperatingHours = ({
  daysOfWeek,
  businessHours,
  timezone,
  isBusinessHourAvailable,
}: OperatingHoursProps) => {
  if (!isBusinessHourAvailable) {
    return (
      <div
        className={[
          "flex",
          "flex-col",
          "w-[312px]",
          "max-md:ml-0",
          "justify-center",
          "items-start",
          "flex gap-4 justify-start items-start",
          "max-md:px-5",
        ].join(" ")}
      >
        No business hours available
      </div>
    );
  }

  const now = new Date();
  const today = now.toLocaleString("en-US", { weekday: "long" }).toLowerCase();

  return (
    <div
      className={[
        "flex",
        "flex-col",
        "justify-center",
        "w-[312px]",
        "max-md:ml-0",
        "max-md:w-full",
        "max-md:px-5",
        "flex gap-5 items-start",
      ].join(" ")}
    >
      <p className={["text-[20px] leading-[25px] font-semibold"].join(" ")}>
        Hours
      </p>
      <div className={["w-full", "flex", "flex-col", "gap-2"].join(" ")}>
        {daysOfWeek.map((day: any) => {
          return (
            <div
              key={day}
              className={[
                "flex",
                "flex-row",
                "justify-between",
                day === today ? "font-bold" : "",
              ].join(" ")}
            >
              <span
                className={[
                  "capitalize",
                  "pr-4",
                  "text-[15px] leading-[22px]",
                ].join(" ")}
              >
                {day}
              </span>
              <div className="flex flex-col text-end">
                {businessHours[day as keyof BusinessHours].length > 0 ? (
                  businessHours[day as keyof BusinessHours].map(
                    (timeSlot: TimeSlot, index: number) => (
                      <span
                        key={index}
                        className={[
                          "text-[15px] leading-[22px]",
                          "text-end",
                        ].join(" ")}
                      >
                        {formatTime(timeSlot.start)} -{" "}
                        {formatTime(timeSlot.end)} {timezone}
                      </span>
                    )
                  )
                ) : (
                  <span>Closed</span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export const formatTime = (time: any) => {
  const hours = Math.floor(time / 100);
  const minutes = time % 100;
  const period = hours >= 12 && hours < 24 ? "PM" : "AM";
  const formattedHours = hours % 12 || 12;
  const formattedMinutes = minutes.toString().padStart(2, "0");
  return `${formattedHours}:${formattedMinutes} ${period}`;
};
